import { format } from 'date-fns';

import { ENVIRONMENT_ACRONYMS } from '@/config/constants';

import type { Application, Evaluation } from '@/types';
import type { RunEvaluationApplication } from '@/features/runEvaluation/components/RunEvaluationDialog/RunEvaluationDialog.types';

export const MOBILE_MEDIA_QUERY = '(max-width: 640px)';

export const getSelectedEnvironmentAcronym = (
  selectedEnvironment: string,
) => {
  const selectedEnvironmentKey = selectedEnvironment.toLowerCase();

  return (
    ENVIRONMENT_ACRONYMS[
      selectedEnvironmentKey as keyof typeof ENVIRONMENT_ACRONYMS
    ] ?? selectedEnvironment.slice(0, 3).toLowerCase()
  );
};

export const getEvaluationRows = (
  pages?: Array<{ data: { items: Evaluation[] } }>,
) => {
  const rows = pages?.flatMap((page) => page.data.items) ?? [];

  if (rows[0]?.totalEvaluations === 0) {
    return [];
  }

  return rows;
};

export const getEvaluationTrendData = (evaluationRows: Evaluation[]) => {
  const items = evaluationRows.slice(0, 10).reverse();

  return items.length > 0
    ? items
    : [{ generatedAt: new Date().toISOString(), score: 0 }];
};

export const getScoreIndicatorColorClass = (
  score: number | null | undefined,
) => {
  if (score === null || score === undefined) {
    return 'bg-gray-400';
  }

  return score === 100 ? 'bg-green-500' : 'bg-red-500';
};

export const getEvaluationReportFilename = (bitId?: string) =>
  `ORR-Evaluation-Report-${bitId}.xlsx`;

export const formatEvaluationGeneratedAt = (generatedAt: string) =>
  format(new Date(generatedAt), 'yyyy-MM-dd HH:mm');

export const sanitizeEvaluationActionId = (evaluationId: string) =>
  evaluationId.replace(/[^a-zA-Z0-9\s]/g, '');

interface RunEvaluationApplicationOptions {
  isOpen: boolean;
  application?: Application;
  selectedEnvironment: string;
}

export const getRunEvaluationApplication = ({
  isOpen,
  application,
  selectedEnvironment,
}: RunEvaluationApplicationOptions): RunEvaluationApplication | null => {
  if (!isOpen) {
    return null;
  }

  return {
    bitId: application?.bitId || '',
    name: application?.name || '',
    environment: selectedEnvironment,
  };
};
